export const APPID = 'ww7cc21822bb873219'

export const AgentID = '1000011'

export const pubKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC3S/EvmxPfUGegIue4526GQ0MHcxEZxH1KmlKeYIBYFyFOaj8QsvA4Bv6l8N0slMfy4oMjh47IMi3o41p0AR1gWwAw9MtO5/lA3PirhHBQnrTkTsuZ2sE7NVhZegpLzccs8Za5+TFA9Sc2WoxC8N8lnzMDQ6DQ9B9y+xPuxdZq8wIDAQAB'

export const localStorageKey = 'zc-new-'

export const selectApi = '/api/backstage/select.do'

export const drawerWidth = '90%'

export const tablePagination = {
  pageSize: 500,
  pageSizeOptions: ['100', '300', '500', '1000'],
  // hideOnSinglePage:true,
  showSizeChanger: true,
}

export const formItemConfig = {
  normal: {
    labelCol: {
      span: 9
    },
    wrapperCol: {
      span: 15
    }
  },
  full: {
    labelCol: {
      span: 3
    },
    wrapperCol: {
      span: 21
    }
  },
}
